import App from './App.vue'
import { createSSRApp } from 'vue'
// import { createPinia } from 'pinia'
import { setupPinia } from './sheep/store';
import i18n from './sheep/i18n';


// 创建 Pinia 实例
// const pinia = createPinia()

export function createApp() {
  const app = createSSRApp(App)

  // 使用 Pinia
  // app.use(pinia)
  setupPinia(app);

  // 使用 i18n
  app.use(i18n)

  return {
    app
  }
}
